module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chap-title1"
  }, [_c('span', [_vm._v("PRIVATE OTIS PIKE")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('sup', [_c('b', [_c('img', {
    staticClass: "svg",
    attrs: {
      "alt": "image",
      "src": "images/fig34-01.jpg"
    }
  })])]), _c('b', [_vm._v("O"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("TIS")]), _vm._v(" M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ATHIAS")]), _vm._v(" P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IKE")])]), _c('br'), _vm._v("Class of 1860")]), _vm._v(" "), _c('p', {
    staticClass: "image-center"
  }, [_c('span', [_c('img', {
    staticClass: "svg",
    attrs: {
      "alt": "image",
      "src": "images/fig04-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("Pvt. 2d Massachusetts Vols. (Infantry) 12 July, 1862. Killed at Gettysburg, Penn., 3 July, 1863.")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('span', [_c('i', [_vm._v("—Harvard Memorial Biographies")])])]), _vm._v(" "), _c('p', {
    staticClass: "normal2"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("O")]), _vm._v("tis was sensible enough to recognize the error of his ways on several occasions in the past.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("For one thing, he should never have loaned five dollars to a penniless classmate.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the second place, he should never have accepted a bowie knife as collateral for the loan. What use did Otis have for a bowie knife? Nevertheless he had stuck it in his belt because it gave him a certain air.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the third place, he should certainly have avoided the low tavern on the Boston waterfront where his pocket had been picked, last year in the summer of ’62.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the fourth place, he should never have attacked the pickpocket with the bowie knife.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The fact was that if Otis Pike, the witty darling of his class, had not been kind enough in the first place to help out a friend, he would not have had to choose between a prison term and recruitment into the Second Massachusetts Volunteer Infantry.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("What kind of choice was that? The prison was an infamous black hole.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You are fortunate, young man,” the judge had said, “that your classmates in a distinguished regiment have spoken up for you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Oh, that was all very well and good, but his dear old college classmates had entered the service as officers, whereas poor old Otis was only a private.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But, Your Honor,” he had pleaded, “when I confronted that man, he attacked me. I could have been killed.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Whereas,” the judge had said sourly, “it was he who had the misfortune to be killed.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But it was self-defense, Your Honor, that’s all. Pure self-defense.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Self-defense! For over a year now, "), _c('i', [_vm._v("self-defense")]), _vm._v(" had been Otis Pike’s watchword in all the battles in which the regiment had been called upon to fight.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In self-defense he had run from the carnage in Miller’s cornfield at Antietam. In self-defense he had fled the slaughter of Chancellorsville. Where now were some of his old comrades in the Second Massachusetts? Where were Wilder Dwight and Tom Spurr and George Batchelder? And Stephen Emerson and William Temple?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Dead at Antietam, dead at Chancellorsville.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Watch your step, Otis,” his captain had warned him. “One more desertion and you’re a dead man.” The captain of Company E was Tom Robeson, fellow reveler and funny fellow.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I warn you, Otis,” his colonel had said, “if you run again, we’ll have no choice.” The colonel of the entire Second Massachusetts Volunteer Infantry was good old Charley Mudge, another comrade from the Hasty Pudding Club, comic gymnast and consummate artist of the banjo.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Otis had snapped a salute. “Yes, sir, Colonel, sir. But, hark! do I hear a mockingbird?” It was a passage from the Minstrels of the class of 1860, every line and note of which had been composed by Otis Pike.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But Charley Mudge had looked at him solemnly and said, “I mean it, Otis. It’s no joke.”")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-20fa76ae","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/part2chapter02.vue
// module id = 93
// module chunks = 0